import { Cell, Divider, Spacer } from '@vinted/web-ui';
import { HC_RECENT_TRANSACTIONS_PATH, HC_TRANSACTION_PATH } from 'constants/routes/help-center';
import { AccessChannel } from 'constants/index';
import SeparatedList from 'components/SeparatedList';
import useTranslate from 'hooks/useTranslate';
import { urlWithParams } from 'libs/utils/url';
import HelpCenterTransactionItem from '../HelpCenterTransactionItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const HelpCenterTransactions = _ref => {
  let {
    transactions,
    hasMoreTransactions
  } = _ref;
  const translate = useTranslate();

  const getTransactionPath = id => urlWithParams(HC_TRANSACTION_PATH(id), {
    access_channel: AccessChannel.HcTransaction
  });

  const renderTransactionItem = transaction => /*#__PURE__*/_jsx(HelpCenterTransactionItem, {
    transaction: transaction,
    cellOptions: {
      url: getTransactionPath(transaction.id),
      type: Cell.Type.Navigating,
      chevron: true,
      testId: 'hc-transaction-link'
    }
  }, transaction.id);

  const renderMoreTransactions = () => {
    if (!hasMoreTransactions) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Cell, {
        title: translate('help_center.transactions.all_recent_orders'),
        url: HC_RECENT_TRANSACTIONS_PATH,
        type: Cell.Type.Navigating,
        testId: "all-recent-orders",
        chevron: true
      })]
    });
  };

  if (!transactions.length) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Cell, {
      styling: Cell.Styling.Tight,
      children: [/*#__PURE__*/_jsx(SeparatedList, {
        separator: /*#__PURE__*/_jsx(Divider, {}),
        children: transactions.map(renderTransactionItem)
      }), renderMoreTransactions()]
    }), /*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.Large
    })]
  });
};

export default HelpCenterTransactions;